import React from "react";
import {
  FaFacebook,
  FaExclamationTriangle,
  FaInfoCircle,
} from "react-icons/fa";

/**
 * Modal thông báo và hướng dẫn kết nối lại fanpage
 * @param {boolean} isOpen - Trạng thái hiển thị modal
 * @param {Function} onClose - Callback khi đóng modal
 * @param {Object} fanpage - Thông tin fanpage cần kết nối lại
 * @param {Function} onReconnect - Callback khi nhấn nút kết nối lại
 * @returns {JSX.Element} - Component ReconnectFanpageModal
 */
const ReconnectFanpageModal = ({ isOpen, onClose, fanpage, onReconnect }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex items-center justify-center mb-4 text-orange-500">
          <FaExclamationTriangle size={40} />
        </div>

        <h2 className="text-xl font-bold text-center mb-4">
          Cần kết nối thủ công
        </h2>

        <p className="mb-4 text-gray-700">
          Không thể tự động kết nối lại fanpage <strong>{fanpage?.name}</strong>
          . Bạn cần thực hiện kết nối thủ công qua Facebook.
        </p>

        <div className="mb-4 bg-blue-50 p-4 rounded-lg">
          <div className="flex items-start">
            <FaInfoCircle className="text-blue-500 mt-1 mr-2 flex-shrink-0" />
            <div>
              <p className="text-sm text-blue-800 font-medium mb-2">
                Khi nhấn "Kết nối qua Facebook":
              </p>
              <ol className="text-sm text-blue-700 list-decimal pl-4 space-y-1">
                <li>Một cửa sổ Facebook sẽ mở ra</li>
                <li>
                  Đăng nhập vào tài khoản Facebook của bạn (nếu chưa đăng nhập)
                </li>
                <li>Chọn "Tiếp tục" để cấp quyền truy cập</li>
                <li>Sau khi hoàn tất, quay lại trang này</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="flex justify-center space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
          >
            Để sau
          </button>

          <button
            onClick={onReconnect}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center"
          >
            <FaFacebook className="mr-2" />
            Kết nối qua Facebook
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReconnectFanpageModal;
